export default __webpack_public_path__ + "static/media/Group 116.b1ee08f5.svg";